import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './SkeletonLoader.css'; // Custom CSS for styling

function NoListData({ message }) {
    return (
        <Container fluid className="vh-100 d-flex align-items-center justify-content-center">
            <Row className="mb-3">
                <Col xs="auto">
                    <h2 className="text-center text-muted">
                        {message || "No Data Found"}
                    </h2>
                </Col>
            </Row>
        </Container>
    );
}

export default NoListData;
